/**
 * feeds-speeds — Kesme hızı / ilerleme hesaplayıcı (pro CAM).
 *
 * RPM = Vc·1000 / (π·D)      (Vc: m/min, D: mm)
 * Feed = fz · z · RPM        (fz: mm/diş, z: diş sayısı)
 *
 * Malzeme presetleri orta-değer (HSS/karbür freze, genel). Kullanıcı ayarlar.
 * Saf/deterministik → unit test edilebilir.
 */

export interface IMalzemeKesim { ad: string; vc: number; fz: number; } // Vc m/min, fz mm/diş

export const MALZEME_KESIM: Record<string, IMalzemeKesim> = {
    aluminyum: { ad: 'Alüminyum', vc: 300, fz: 0.10 },
    yumusakCelik: { ad: 'Yumuşak Çelik', vc: 120, fz: 0.06 },
    alasimliCelik: { ad: 'Alaşımlı Çelik', vc: 90, fz: 0.05 },
    paslanmaz: { ad: 'Paslanmaz', vc: 70, fz: 0.04 },
    dokum: { ad: 'Döküm Demir', vc: 100, fz: 0.08 },
    pirinc: { ad: 'Pirinç', vc: 200, fz: 0.10 },
    bakir: { ad: 'Bakır', vc: 180, fz: 0.09 },
    titanyum: { ad: 'Titanyum', vc: 45, fz: 0.04 },
    plastik: { ad: 'Plastik', vc: 400, fz: 0.15 },
    ahsap: { ad: 'Ahşap', vc: 500, fz: 0.20 },
};

/** Kesme hızı (Vc, m/min) + çaptan (mm) RPM */
export function rpmHesapla(vc: number, capMm: number): number {
    if (capMm <= 0 || vc <= 0) return 0;
    return Math.round((vc * 1000) / (Math.PI * capMm));
}

/** İlerleme (mm/min) = fz · diş · RPM */
export function ilerlemeHesapla(fz: number, disSayisi: number, rpm: number): number {
    if (rpm <= 0 || fz <= 0) return 0;
    return Math.round(fz * Math.max(1, disSayisi) * rpm);
}

/** Malzeme + çap + diş → {rpm, ilerleme, vc, fz}. Bilinmeyen malzeme → null. */
export function feedsSpeeds(malzeme: string, capMm: number, disSayisi: number): { rpm: number; ilerleme: number; vc: number; fz: number } | null {
    const m = MALZEME_KESIM[malzeme];
    if (!m) return null;
    const rpm = rpmHesapla(m.vc, capMm);
    return { rpm, ilerleme: ilerlemeHesapla(m.fz, disSayisi, rpm), vc: m.vc, fz: m.fz };
}
